import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b426939a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-overlay" }




export default /*#__PURE__*/_defineComponent({
  __name: 'OverlayLoader',
  props: ['loading'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, null, 512)), [
    [_vShow, __props.loading]
  ])
}
}

})